exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ColorPicker button{\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tmargin: 2px;\r\n}\r\n\r\n.ColorPicker.ColorInput {\r\n\tposition: relative;\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tmargin-bottom: 10px;\r\n\tborder: 1px solid #AAA;\r\n\tmargin-top: 5px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/ColorPicker/ColorPicker.css
// module id = 682
// module chunks = 0